interface EnvConfig {
  apiUrl: string
  appName: string
  isDevelopment: boolean
}

const getEnvConfig = (): EnvConfig => {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:4000'
  const appName = import.meta.env.VITE_APP_NAME || 'NeoSV'
  const isDevelopment = import.meta.env.DEV

  return {
    apiUrl,
    appName,
    isDevelopment,
  }
}

export const env = getEnvConfig()
